import { useTheme } from "styled-components";
import React, { useMemo } from "react";
import { Cell, Legend, Pie, PieChart, ResponsiveContainer } from "recharts";
import { Box } from "../Box";
import { Tooltip } from "../Tooltip";
import { EmptyChart } from "./EmptyChart";
import { PopoverContents } from "./internal/PopoverContents";
import { doesPieChartHaveData, formattedLegendText, getDataFillColor, TRANSLATERISKS, } from "./helpers";
export const HalfPieChart = ({ cursor, data, isAnimationActive, isRiskChart, emptyMessage, emptyMessageFontSize, noLegend, outerRadius = "35", popoverContentsColumns = [], responsiveContainerHeight = "100%", responsiveContainerWidth = "100%", showPopover = true, tooltip, }) => {
    const theme = useTheme();
    const { colors: { chartColors }, } = theme;
    const pieChartHasData = useMemo(() => (data === null || data === void 0 ? void 0 : data.length) && doesPieChartHaveData(data), [data]);
    // Sort
    if (pieChartHasData) {
        if (isRiskChart) {
            data.sort((a, b) => TRANSLATERISKS[b.name] - TRANSLATERISKS[a.name]);
        }
        else {
            data.sort((a, b) => {
                if (a.value > b.value)
                    return -1;
                if (a.value < b.value)
                    return 1;
                return 0;
            });
        }
    }
    const needsResponsiveContainer = typeof responsiveContainerWidth === "string" || typeof responsiveContainerHeight === "string";
    return pieChartHasData ? (React.createElement(Tooltip, { content: showPopover ? React.createElement(PopoverContents, { columns: popoverContentsColumns, pieData: data }) : undefined, variant: "table" },
        React.createElement(Box, { "data-testid": "halfPieChart", width: "100%" },
            React.createElement(ResponsiveContainer, { id: "rechartsHalfPieChartDiv", height: responsiveContainerHeight, width: needsResponsiveContainer ? responsiveContainerWidth : "100%" },
                React.createElement(PieChart, Object.assign({}, (needsResponsiveContainer
                    ? {}
                    : { height: responsiveContainerHeight, width: responsiveContainerWidth })),
                    React.createElement(Pie, { cursor: cursor, cx: "50%", cy: "100%", data: data, dataKey: "value", endAngle: 0, innerRadius: 0, isAnimationActive: isAnimationActive, nameKey: "name", outerRadius: outerRadius, startAngle: 180, stroke: "none" }, data.map((entry, index) => (React.createElement(Cell, { key: `cell-${entry.name}`, fill: entry.fill ||
                            getDataFillColor({
                                entry,
                                index,
                                isRiskChart,
                                theme,
                            }) })))),
                    tooltip,
                    !noLegend && (React.createElement(Legend, { content: (props) => formattedLegendText({ chartColors, props }), wrapperStyle: { left: 0, width: "100%" } }))))))) : (React.createElement(Box, { "data-testid": "rechartsHalfPieChartNoData", style: { height: responsiveContainerHeight, width: responsiveContainerWidth } },
        React.createElement(EmptyChart, { emptyMessage: emptyMessage, emptyMessageFontSize: emptyMessageFontSize })));
};
